export default __webpack_public_path__ + "static/media/IMG_6327.11409566.JPG";